<template>
  <hypto-popup :title="'Invalid Credits Filter'">
    <template v-slot:body>
      <div class="merge-fields">
        <date-time-picker @updateDateTime="(newVal) => timeRange = newVal"
                          :reset="resetRange" :timeRange="timeRange" />

        <md-field id="PaymentType">
          <label>Payment Types</label>
          <md-select v-model="paymentTypes" @md-opened="setDropdownPosOffset('PaymentType')" multiple>
            <md-option v-for="(payment, index) in paymentOptions" :key="index" :value="payment">
              {{payment}}
            </md-option>
          </md-select>
        </md-field>

        <md-field id="Statuses">
          <label>Statuses</label>
          <md-select v-model="statuses" @md-opened="setDropdownPosOffset('Statuses')" multiple>
            <md-option v-for="(status, index) in statusOptions" :key="index" :value="status">
              {{status}}
            </md-option>
          </md-select>
        </md-field>

        <div class="radio-btns">
          <h5>Sort Order</h5>
          <md-radio v-model="sortOrder" :value="'DESC'">Latest</md-radio>
          <md-radio v-model="sortOrder" value="ASC">Oldest</md-radio>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <button class="dark-btn" @click="reset">Reset</button>
      <button class="primary-btn" @click="filterAction">Apply Filter</button>
    </template>
  </hypto-popup>
</template>

<script>
import DateTimePicker from '@/components/global/DateTimePicker'
import HyptoPopup from '@/components/global/HyptoPopup'

import { mapGetters } from 'vuex'
import { setDropdownPosOffset } from '@/utils/helpers'
import { DataBuilder, ParamsBuilder } from '@/utils/helpers/classes'

export default {
  name: 'VAInvalidCreditsFilter',
  components: { DateTimePicker, HyptoPopup },
  data () {
    return {
      paymentOptions: [
        'UPI',
        'IMPS',
        'NEFT',
        'RTGS',
        'FT'
      ],
      statusOptions: [
        'PENDING',
        'FAILED',
        'COMPLETED',
        'REFUNDED_BY_BANK',
        'NEED_REMITTER_DETAILS',
        'SETTLED_TO_HYPTO'
      ],
      paymentTypes: null,
      statuses: null,
      sortOrder: 'DESC',
      timeRange: [],
      resetRange: false
    }
  },
  computed: {
    ...mapGetters(['getterStatementFilter'])
  },
  created () {
    this.populateData()
  },
  methods: {
    setDropdownPosOffset,
    populateData () {
      let filterData = new DataBuilder(this.getterStatementFilter)
      this.paymentTypes = filterData.getValue('payment_types')
      this.statuses = filterData.getValue('statuses')
      this.sortOrder = filterData.getValue('sort_order', false, 'DESC')
      let startTime = filterData.getValue('start_time', true, '')
      let endTime = filterData.getValue('end_time', true, '')
      this.timeRange.push(startTime, endTime)
    },
    filterAction () {
      let params = new ParamsBuilder(this.timeRange, null, this.paymentTypes, this.statuses, this.sortOrder).getParams()
      this.$emit('updateFilters', params)
    },
    reset () {
      this.paymentTypes = null
      this.statuses = null
      this.sortOrder = 'DESC'
      this.resetRange = !this.resetRange
    }
  }
}
</script>
